<ion-button *ngIf="isMyTask" expand="block" (click)="showAddAttachment()">
  {{ 'Mobile.AddAttachment' | translate }}
</ion-button>
